// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"rX-z","sponsoredTooltipWrapper":"sX-z","sponsoredTooltip":"tX-z","newCard":"uX-z"};